import { request } from '@/api/apiUtils';
import { createEntityQuery } from '@/data/createEntityQuery';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { IImportReport } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const IMPORT_REPORTS_ROOT = ['importReports'] as const;

interface ImportReportsListParams {
    projectId: number;
}

const fetchers = {
    list: {
        key: ({ projectId }: ImportReportsListParams) => [...IMPORT_REPORTS_ROOT, 'list', projectId] as const,
        // Endpoint returns a bare array (not the { data } envelope), so return it directly.
        fetch: ({ projectId }: ImportReportsListParams): Promise<IImportReport[]> => request(`projects/${projectId}/import-reports`),
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const importReportsEntity: EntityDefinition<typeof fetchers> = {
    name: 'importReports',
    roots: [IMPORT_REPORTS_ROOT],
    fetchers,
};

export const useImportReportsList = createEntityQuery(importReportsEntity, 'list');

export type { ImportReportsListParams };
